"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const flora_default_1 = __importStar(require("./flora-default"));
exports.default = Object.assign(Object.assign({}, flora_default_1.default), { name: 'Boticario', type: Object.assign({}, (0, flora_default_1.typeGenerator)('"Domaine Sans", Times, Serif', '"DM Sans", Arial, Helverica, Sans-Serif', {
        l1: 500,
        l2: 500,
        l3: 500,
        l4: 500,
        l5: 500,
        l6: 500,
        bodyLargeStandardRegular: 500,
        bodyLargeShortRegular: 500,
        bodyMediumStandard: 500,
        bodyMediumShort: 500,
        exceptionsAuxiliarRegular: 500,
        auxiliarMini: 500,
        overline: 500,
        action: 500,
    })), colors: Object.assign(Object.assign({}, flora_default_1.default.colors), { build: {
            brand: {
                primary: '#007E78',
                secondary: '#A9CB7A',
                tertiary: '#65987C',
            },
            dark: {
                default: '#000000',
                light: '#000000',
            },
            light: {
                default: '#FFFFFF',
                dark: {
                    primary: '#F5F5F5',
                    secondary: '#FFFFFF',
                },
            },
            medium: {
                default: '#878787',
                light: {
                    primary: '#515151',
                    secondary: '#CCCCCC',
                },
            },
            gradient: {
                primary: {
                    first: '#007E78',
                    end: '#007E78',
                },
                secondary: {
                    first: '#A9CB7A',
                    end: '#A9CB7A',
                },
            },
        }, action: {
            conversion: {
                static: '#384ECA',
                highlight: '#304873',
                disabled: 'rgba(0, 0, 0, 0.16)',
            },
            navigation: {
                standard: {
                    static: '#499D71',
                    highlight: '#37736C',
                    disabled: 'rgba(0, 0, 0, 0.16)',
                },
                alt: {
                    static: '#FFFFFF',
                    highlight: '#A9CB7A',
                    disabled: 'rgba(255, 255, 255, 0.24)',
                },
            },
            gradient: {
                conversion: {
                    first: '#384ECA',
                    end: '#384ECA',
                },
                navigation: {
                    first: '#499D71',
                    end: '#499D71',
                },
            },
        } }) });
